<div class="app-scroll-wrapper">
<div class="container">
  <div class="back-section">
    <a mat-flat-button color="accent" routerLink="../../visits">{{ 'scheduler.general.back-to-list' | translate }}</a>
  </div>

  @if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (isError) {
  <mat-card>
    <mat-card-header>
      {{ errorMessage | translate }}
    </mat-card-header>
    <mat-card-actions>
      <button (click)="retryLoad()" mat-button>{{ 'scheduler.general.retry' | translate }}</button>
    </mat-card-actions>
  </mat-card>
  }

  @if (!isLoading && !isError) {
  <mat-card class="header-card">
    <mat-card-header>
      <div mat-card-avatar class="header-avatar">
        <mat-icon>business</mat-icon>
      </div>
      <mat-card-title>Visit Type</mat-card-title>
      @if (visitType) {
      <mat-card-subtitle>{{ visitType.description }}</mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content>
      <p>
        You can manage the required resources for this visit type here. To associate new SOR codes, please use the SOR
        code admin screen.
      </p>
    </mat-card-content>
  </mat-card>
  }

  @if (!isLoading && !isError) {
  <mat-accordion class="entity-managers">

    @if (visitType) {
    <app-visit-type-resource-grid [visitType]="visitType">
    </app-visit-type-resource-grid>
    }
    @if (visitType) {
    <app-child-entity-manager [childEntityModel]="childEntities.sorCode" [resource]="visitType">
    </app-child-entity-manager>
    }
  </mat-accordion>
  }

</div>
</div>
